




























































import Vue from 'vue';
import Component from 'vue-class-component';
import { healthReports } from '@/modules/reports/shared/store/namespaces';
import { HealthReportsActions } from '@/modules/reports/health-reports/store/health-reports.actions';
import { HealthReportsGetters } from '@/modules/reports/health-reports/store/health-reports.getters';
import { HealthReportManagementView } from '@/modules/reports/health-reports/domain/health-report-management-view';
import { Customer } from '@/modules/customers/domain/customer';
import { Emit, Prop, Watch } from 'vue-property-decorator';
import { EventBus } from '@/main';
import { EventBusMessages } from '@/modules/shared/shared/domain/constants/event-bus-messages';

@Component({
    name: 'customer-selection',
})
export default class CustomersSelection extends Vue {
    @Prop({ required: false, type: Boolean, default: false })
    hideCheck!: boolean;

    private isLoading: boolean = false;

    private itemsPerPage: number[] = [5, 10, 15, 20];
    private pageOptions: any = {};
    private limit = 10;

    private customerSelected: Partial<Customer> = {};

    private page = 1;
    private search: string = '';

    get headers() {
        let h = [
            { text: 'Cliente', sortable: false, value: 'name' },
            { text: 'RIF', sortable: false, value: 'rif' },
        ];

        if (!this.hideCheck) {
            h = [{ text: '', sortable: false, value: '' }, ...h];
        }
        return h;
    }

    async mounted() {
        this.isLoading = true;
        const failed = await this.fetchCustomers();
        if (failed) {
            failed.showError();
        }
        this.isLoading = false;
    }

    @Emit('customerSelection')
    changeCustomer(customer: Customer) {
        this.customerSelected = customer;
        return this.customerSelected;
    }

    async changePage() {
        this.isLoading = true;
        const failed = await this.changeAPage({
            page: this.page,
            limit: this.limit,
        });
        if (failed) {
            failed.showError();
        }
        this.isLoading = false;
    }

    async findCustomers() {
        this.isLoading = true;
        const failed = await this.searchCustomer(this.search);
        if (failed) {
            failed.showError();
        }
        this.isLoading = false;
    }

    @Watch('pageOptions.itemsPerPage')
    onItemsPerPageChanged(value) {
        this.limit = value;
        this.page = 1;
        this.changePage();
    }

    public getSelectedCustomerId(): number | undefined {
        if (!this.customerSelected.id) {
            EventBus.$emit(
                EventBusMessages.SHOW_ERROR,
                'Para continuar es necesaria la seleción un cliente',
            );
            return undefined;
        }
        return this.customerSelected.id;
    }

    public reset() {
        this.customerSelected = {};
    }

    @healthReports.Action(HealthReportsActions.FETCH_CUSTOMERS)
    fetchCustomers!: () => Promise<RequestResponse>;

    @healthReports.Action(HealthReportsActions.CHANGE_PAGE)
    changeAPage!: ({ page, limit }) => Promise<RequestResponse>;

    @healthReports.Action(HealthReportsActions.SEARCH_CUSTOMER)
    searchCustomer!: (search: string) => Promise<RequestResponse>;

    @healthReports.Getter(HealthReportsGetters.GET_MANAGEMENT_VIEW)
    view!: HealthReportManagementView;
}
